import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import { TEXT } from '../../theme/tokens'

/**
 * The eyebrow label of a Bulk Send section: the theme's overline slot
 * (uppercase, tracked), bold as the brand sheet's overline is, in the muted
 * text tier.
 */
const Overline = ({ children, component = 'h3', sx }) => (
    <Typography
        variant="overline"
        component={component}
        sx={{
            display: 'block',
            color: TEXT.muted,
            fontWeight: 700,
            lineHeight: 1.6,
            ...sx,
        }}
    >
        {children}
    </Typography>
)

Overline.propTypes = {
    children: PropTypes.node.isRequired,
    component: PropTypes.string,
    sx: PropTypes.object,
}

export default Overline
